export default __webpack_public_path__ + "static/media/slot9.e6c8ba10.png";